import { render } from "./PartnerLogoHeader.vue?vue&type=template&id=35287716"
import script from "./PartnerLogoHeader.vue?vue&type=script&lang=js"
export * from "./PartnerLogoHeader.vue?vue&type=script&lang=js"

import "./PartnerLogoHeader.vue?vue&type=style&index=0&id=35287716&lang=scss&rel=stylesheet%2Fscss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__